'use strict';
module.exports = require('./Carousel.vue');